export enum UserRole {
  CLIENT = 'client',
  EMPLOYEE = 'employee',
  ADMIN = 'admin'
}

export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  phone?: string
  role: UserRole
  lastLoginAt?: string
  createdAt: string
  updatedAt: string
}

export interface UserCredentials {
  email: string
  password: string
}

export interface UserProfile {
  firstName: string
  lastName: string
  phone?: string
  email: string
} 